import axiosBackend from "../config/axios/axios-back-end";

export const getDocumentTypes = async () => {
  const response = await axiosBackend.get("/api/lmd-indexing/document-types");
  return response.data;
};

export default {
  getDocumentTypes,
};
